<div class="w-full max-w-5xl mx-auto sm:min-h-screen
            bg-white md:rounded-lg md:shadow-lg md:p-6
            p-4 flex flex-col">
  <div class="relative flex items-center justify-center">
    <!-- Botón a la izquierda -->
    <button class="absolute left-0 mb-2" (click)="goBack()">
      <app-metro-icon [svg]="iconBack" size="20" color="'bg-metro-blue'"></app-metro-icon>
    </button>

    <h2 class="text-lg font-semibold">{{ '::OrderDetail' | abpLocalization }}</h2>
  </div>
  <div class="mt-3 px-4 space-y-4">
    <h2 class="text-lg  text-metro-blue-secondary font-bold  tracking-wide">{{ '::Order' | abpLocalization }}
      #{{ order.id }}</h2>

  </div>
  <!-- Products -->
  <div class="px-4 space-y-4" *ngIf="order">
    @for (item of order.orderItems; track $index) {
    <div class="flex items-center gap-4">

      <div class="w-14 h-14 flex items-center justify-center">
        <img [src]="item.wine?.imageUrl || 'assets/images/no-image.png'"
          class="max-w-full max-h-full object-contain rounded-lg" [alt]="item.wineName || item.wine?.name || ''"
          onerror="this.src='assets/images/no-image.png'">
      </div>

      <div>
        <div class="font-semibold">{{ item.wineName || item.wine?.name || '' }}</div>
        <div class="text-metro-blue text-sm">{{ item.quantity }} {{ item.quantity > 1 ? ('::Bottles' | abpLocalization)
          : ('::Bottle' | abpLocalization) }}</div>
      </div>
    </div>

    }

  </div>
  <div class="px-4 pt-6" *ngIf="order">
    <h2 class="font-bold text-lg mb-2">{{ '::OrderInfo' | abpLocalization }}</h2>
    <div class="border-t">

      @if (isClient || isSommelier) {
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::DeliveryMethod' | abpLocalization }}</div>
        <div class="font-medium">{{ '::' + (order.deliveryMethod === 'pickup' ? 'Pickup' : 'MeetWithSommelier') | abpLocalization }}</div>
      </div>
      @if (order.pickupAddress) {
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::PickupAddress' | abpLocalization }}</div>
        <div class="font-medium">{{ order.pickupAddress }}</div>
      </div>
      }
      @if (order.customerAddress) {
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::Address' | abpLocalization }}</div>
        <div class="font-medium">{{ formatCustomerAddress(order) }}</div>
      </div>
      }
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::DeliveryCode' | abpLocalization }}</div>
        <div class="font-medium tracking-widest text-metro-blue">{{ order.deliveryCode }}</div>
      </div>
      }
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::Date' | abpLocalization }}</div>
        <div class="font-medium">{{ order.creationTime | date:'dd/MM/yyyy' }}</div>
      </div>
      <!-- winepassport#346 — sommelier histórico: el que tenía la orden al ejecutarse (Order.SommelierId es snapshot) -->
      @if (order.sommelierName) {
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::Sommelier' | abpLocalization }}</div>
        <div class="font-medium">{{ order.sommelierName }}</div>
      </div>
      }
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::Status' | abpLocalization }}</div>
        <div class="font-medium">{{ '::' + getOrderStatusString(order.orderStatus) | abpLocalization }}</div>
      </div>
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::PaymentMethod' | abpLocalization }}</div>
        <div class="font-medium">{{ order.paymentMethod || ('::NotSpecified' | abpLocalization) }}</div>
      </div>
      @if (order.priceListName) {
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::PriceList' | abpLocalization }}</div>
        <div class="font-medium">{{ order.priceListName }}</div>
      </div>
      }
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::Name' | abpLocalization }}</div>
        <div class="font-medium">{{ order.userName }} {{order.userSurname}}</div>
      </div>
      <!-- Desglose de importes -->
      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::SubTotal' | abpLocalization }}</div>
        <div class="font-medium">${{ order.subTotal | number:'1.2-2' }}</div>
      </div>

      <div class="py-3 border-b">
        <div class="text-metro-blue text-sm">{{ '::Tax' | abpLocalization }} 21%</div>
        <div class="font-medium">${{ order.tax | number:'1.2-2' }}</div>
      </div>

      <div class="py-3 border-b" *ngIf="order.couponCode">
        <div class="text-metro-blue text-sm">{{ '::Discount' | abpLocalization }} ({{ order.couponCode }})</div>
        <div class="font-medium text-red-500">-${{ order.couponDiscountAmount | number:'1.2-2' }}</div>
      </div>

      <div class="py-3 border-b" *ngIf="order.interestCharge > 0">
        <div class="text-metro-blue text-sm">{{ '::InterestCharge' | abpLocalization }}</div>
        <div class="font-medium">${{ order.interestCharge | number:'1.2-2' }}</div>
      </div>

      <div class="py-3">
        <div class="text-metro-blue text-sm">{{ '::Total' | abpLocalization }}</div>
        <div class="font-bold text-lg text-metro-blue-secondary">${{ order.total | number:'1.2-2' }}</div>
      </div>

      <!-- Deliver Button -->
      <div class="py-4 mt-2 border-t flex justify-center" *ngIf="showDeliverButton">
        <app-metro-button variant="primary" text="{{ '::Deliver' | abpLocalization }}" [fullWidth]="false" [size]="'sm'"
          (clicked)="openDeliverModal()">
        </app-metro-button>

      </div>
    </div>
  </div>

  <app-metro-modal [isOpen]="showDeliverModal" [title]="'::Deliver' | abpLocalization" [closeOnConfirm]="false"
    (confirm)="deliverForm.submit()" (close)="showDeliverModal = false" [confirmText]="'::Confirm' | abpLocalization">

    @if (showDeliverModal) {
    <app-deliver-order-form (submitted)="onDeliverConfirm($event)" (cancelled)="showDeliverModal = false">
    </app-deliver-order-form>
    }
  </app-metro-modal>

</div>
